module.exports = __webpack_public_path__ + "img/Flecha_verde_izquierda.62f00a5c.svg";